// Collection operators (pure)
const THIS = 'this';
const PARENT = 'parent';
const ROOT = 'root';
const KEY = 'key';
const PAYLOAD = 'payload';
const VALUE_AT = 'byIndex';
const GET_BY_KEY = 'byKey';
const KEY_AT = 'keyAt';

const QUERY = 'query';
const MATCH = 'match';

export default {
    THIS,
    PARENT,
    ROOT,
    KEY,
    PAYLOAD,

    VALUE_AT,
    GET_BY_KEY,
    KEY_AT,

    QUERY,
    MATCH,
};
